import { useInclinicStore } from '@/store';
import { ReservationDeviceOrigin } from '@/types-aggregatore';

export const postMessageToApp = (message: string) => {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(message);
  }
};

export const useIsApp = () => {
  const channel = useInclinicStore(store => store.channel);
  const headerVersion = useInclinicStore(store => store.headerVersion);

  if (headerVersion === 'old') {
    return false;
  }

  return channel === ('APP' as ReservationDeviceOrigin);
};
